module.exports = __webpack_public_path__ + "img/homesol_5.b60536c8.png";